import { defineStore } from "pinia";
import { TaskState } from "./types";
import { TaskDto } from "@/api/entities/tasks";

export const useTaskStore = defineStore("task", {
  state: (): TaskState => ({
    tasks: [],
    loaded: false
  }),
  actions: {
    setState(tasks: TaskDto[]) {
      if (!tasks || !Array.isArray(tasks)) return;
      const sortedTasks = tasks.sort(
        (a, b) => +new Date(a.created) - +new Date(b.created)
      );
      this.tasks = sortedTasks;
      this.loaded = true;
      return sortedTasks;
    },
    updateTask(task: TaskDto) {
      const index = this.tasks.findIndex(t => t.id === task.id);
      if (index >= 0) {
        this.tasks[index] = task;
      } else {
        this.tasks.push(task);
      }
    }
  }
});
